import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { ShoppingCart, Heart, ListOrdered, ArrowLeft } from 'lucide-react';
import { useStore } from '../../contexts/StoreProvider';

const StoreLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useStore();

  const cartItemsCount = cart.reduce((total, item) => total + item.quantity, 0);

  const handleBack = () => {
    if (location.pathname === '/store' || location.pathname === '/store/') {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Store Navigation Bar */}
      <nav className="bg-white border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <button 
                onClick={handleBack}
                className="mr-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
                title="Back"
              >
                <ArrowLeft size={20} />
              </button>
              <Link to="/store" className="text-xl font-bold tracking-widest text-black">
                EMBA STORE
              </Link>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-6">
              <Link to="/store/favorites" className="text-gray-600 hover:text-red-500 transition-colors">
                <Heart size={22} />
              </Link>
              <Link to="/store/orders" className="text-gray-600 hover:text-black transition-colors">
                <ListOrdered size={22} />
              </Link>
              <Link to="/store/cart" className="relative text-gray-600 hover:text-black transition-colors">
                <ShoppingCart size={22} />
                {cartItemsCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-black text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                    {cartItemsCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default StoreLayout;
